import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

// Helper function to get the start of a month
const getMonthStart = (date: Date): string => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const startDate = new Date(year, month, 1);
  return startDate.toISOString();
};

// Helper function to get the end of a month
const getMonthEnd = (date: Date): string => {
  const year = date.getFullYear();
  const month = date.getMonth();
  const endDate = new Date(year, month + 1, 0);
  return endDate.toISOString();
};

export const payAllInstallmentsOperation = async (
  startMonth: Date | null,
  endMonth: Date | null,
  setLoading: (loading: boolean) => void,
  onSuccess: () => void,
): Promise<boolean> => {
  if (!startMonth || !endMonth) {
    toast.warn('יש לבחור טווח חודשים לפני ביצוע הפעולה');
    return false;
  }

  try {
    setLoading(true);

    const startDate = getMonthStart(startMonth);
    const endDate = getMonthEnd(endMonth);

    const res = await appApi.payAllInstallments(startDate, endDate);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return false;
    }

    toast.success('כל התשלומים נגבו בהצלחה');
    setLoading(false);
    onSuccess();
    return true;
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
    return false;
  }
};
